import { store } from '../../../_helpers'



export const orientation_based_attr = () => {
    return store.getState().orientationReducer.orientaionData.data
}

// export const orientation_based_attr = {
//     "orientaions": [
//         {
//             "orientation__orientation_name": "Achievement",
//             "attributes": [
//                 {
//                     "attribute__attribute_name": "Aspiration",
//                     "attribute_id": 1
//                 },
//                 {
//                     "attribute__attribute_name": "Optimization",
//                     "attribute_id": 11
//                 },
//                 {
//                     "attribute__attribute_name": "Planning",
//                     "attribute_id": 23
//                 },
//                 {
//                     "attribute__attribute_name": "Involvement",
//                     "attribute_id": 16
//                 },
//                 {
//                     "attribute__attribute_name": "Time sense",
//                     "attribute_id": 24
//                 },
//                 {
//                     "attribute__attribute_name": "Ownership",
//                     "attribute_id": 6
//                 }
//             ],
//             "orientation_id": 2
//         },
//         {
//             "orientation__orientation_name": "Learning",
//             "attributes": [
//                 {
//                     "attribute__attribute_name": "Initiative",
//                     "attribute_id": 14
//                 },
//                 {
//                     "attribute__attribute_name": "Integration",
//                     "attribute_id": 21
//                 },
//                 {
//                     "attribute__attribute_name": "Urge to Learn",
//                     "attribute_id": 4
//                 },
//                 {
//                     "attribute__attribute_name": "Openness",
//                     "attribute_id": 9
//                 },
//                 {
//                     "attribute__attribute_name": "Understanding",
//                     "attribute_id": 20
//                 },
//                 {
//                     "attribute__attribute_name": "Time for Learning",
//                     "attribute_id": 29
//                 },
//                 {
//                     "attribute__attribute_name": "Structured",
//                     "attribute_id": 28
//                 }
//             ],
//             "orientation_id": 3
//         },
//         {
//             "orientation__orientation_name": "Leadership",
//             "attributes": [
//                 {
//                     "attribute__attribute_name": "Task Involvement",
//                     "attribute_id": 18
//                 },
//                 {
//                     "attribute__attribute_name": "Organized",
//                     "attribute_id": 26
//                 },
//                 {
//                     "attribute__attribute_name": "Influence",
//                     "attribute_id": 3
//                 },
//                 {
//                     "attribute__attribute_name": "Empowerment",
//                     "attribute_id": 8
//                 },
//                 {
//                     "attribute__attribute_name": "Credibility",
//                     "attribute_id": 13
//                 },
//                 {
//                     "attribute__attribute_name": "People Involvement",
//                     "attribute_id": 19
//                 },
//                 {
//                     "attribute__attribute_name": "Prioritization",
//                     "attribute_id": 27
//                 }
//             ],
//             "orientation_id": 1
//         },
//         {
//             "orientation__orientation_name": "Relationship",
//             "attributes": [
//                 {
//                     "attribute__attribute_name": "Expression",
//                     "attribute_id": 2
//                 },
//                 {
//                     "attribute__attribute_name": "Acceptance",
//                     "attribute_id": 7
//                 },
//                 {
//                     "attribute__attribute_name": "Responsibility",
//                     "attribute_id": 12
//                 },
//                 {
//                     "attribute__attribute_name": "Sensitivity",
//                     "attribute_id": 17
//                 },
//                 {
//                     "attribute__attribute_name": "Appropriateness",
//                     "attribute_id": 25
//                 }
//             ],
//             "orientation_id": 5
//         },
//         {
//             "orientation__orientation_name": "Nurturing",
//             "attributes": [
//                 {
//                     "attribute__attribute_name": "Outspokenness",
//                     "attribute_id": 5
//                 },
//                 {
//                     "attribute__attribute_name": "Conviction",
//                     "attribute_id": 22
//                 },
//                 {
//                     "attribute__attribute_name": "Authenticity",
//                     "attribute_id": 15
//                 },
//                 {
//                     "attribute__attribute_name": "Context Sensitivity",
//                     "attribute_id": 30
//                 },
//                 {
//                     "attribute__attribute_name": "Concern",
//                     "attribute_id": 10
//                 }
//             ],
//             "orientation_id": 4
//         }
//     ]
// }


// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/ori_att.js